import { useEffect, useRef, useState } from 'react';
import { loadPdfDocument, renderThumbnail } from '../utils/pdfRender.js';
import { Icon } from './Icon.jsx';

// Renders the first page of a PDF blob as an image. Used by the history
// preview panels. `loading` forces the loading state while a parent is
// still producing the blob (e.g. generating a letter PDF).
export function PdfPreview({ blob, loading = false, loadingLabel, emptyLabel }) {
  const [url, setUrl] = useState(null);
  const [state, setState] = useState('idle'); // idle | loading | done | error
  const reqRef = useRef(0);

  useEffect(() => {
    const req = ++reqRef.current;
    if (!blob) {
      setUrl(null);
      setState('idle');
      return;
    }
    setState('loading');
    setUrl(null);
    let alive = true;
    (async () => {
      try {
        const buf = new Uint8Array(await blob.arrayBuffer());
        const doc = await loadPdfDocument(buf);
        const dataUrl = await renderThumbnail(doc, 0, 1.4);
        if (alive && req === reqRef.current) {
          setUrl(dataUrl);
          setState('done');
        }
      } catch {
        if (alive && req === reqRef.current) setState('error');
      }
    })();
    return () => {
      alive = false;
    };
  }, [blob]);

  if (loading || state === 'loading') {
    return (
      <div className="pdf-preview is-empty">
        <span className="pdf-preview-spin" />
        <span className="tiny muted">{loadingLabel}</span>
      </div>
    );
  }
  if (state === 'error' || (state !== 'done' && !url)) {
    return (
      <div className="pdf-preview is-empty">
        <Icon name="doc" size={26} />
        <span className="tiny muted">{emptyLabel}</span>
      </div>
    );
  }
  return (
    <div className="pdf-preview">
      <img src={url} alt="" />
    </div>
  );
}
